export function IsCustomsRequired(isDocument, pickup){
    
}

const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

export function ToBase64String(file){
    return toBase64(file);
}